import React from 'react';
import Box from '../Box/Box';
import Icon from '../Icon/Icon';

import TToastClose from './@types/TToastClose';

const ToastClose = ({ onClose }: TToastClose) => (
  <Box as="div" parent="Toast" name="close">
    <Icon name="close_small" size="m" onClick={onClose} />
  </Box>
);

export default ToastClose;
